import { render, staticRenderFns } from "./NoDataBox.vue?vue&type=template&id=603307ce&scoped=true&"
import script from "./NoDataBox.vue?vue&type=script&lang=js&"
export * from "./NoDataBox.vue?vue&type=script&lang=js&"
import style0 from "./NoDataBox.vue?vue&type=style&index=0&id=603307ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603307ce",
  null
  
)

export default component.exports